<!-- <iframe width="100%" height="100%" [src]="shibbolethLogoutUrl | safe" aria-hidden="true"></iframe> -->
<div class="sign-in-box-container">
  <div class="sign-in-box-inner-container">
    <div class="logo-box p-g-10 p-md-6 p-lg-6 p-md-offset-1 p-lg-offset-1 p-g-offset-1 p-g-nopad">
      <div class="form-field p-g-4 p-g-nopad">
        <img src='/assets/images/temp/nbx_login_logo.svg' alt="logo">
      </div>
      <div class="logo-box">
        <div class="form-field p-g-11 p-g-nopad">
          <h1 translate>You have successfully logged out</h1>
          <h2>If you logged into other services that use Shibboleth, your session in those services
            may still be active. For optimal security, log out from all other Shibboleth services or close your
            browser.</h2>
          <div>
            <div class="form-field p-g-3 p-g-nopad">
              <button pButton class='sign-in-buttons' (click)="onLogin()" label="Login"></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
